import {
  ShareMessageFragment,
  ShareRoomFragment,
  ShareRoomMemberFragment,
} from "~/__generated__/graphql"
import { getMetaContent, getMetaContentMaybe } from "~/common/get-meta-content"

export const getInviterData = () => {
  return getMetaContentMaybe<ShareRoomMemberFragment>("inviter-data", {
    json: true,
  })
}

export const getMessageData = () => {
  return getMetaContentMaybe<ShareMessageFragment>("message-data", {
    json: true,
  })
}

export const getRoomData = () => {
  // SPA application will not be rendered server-side if a given room cannot be found, or sharing is disabled.
  // Therefore, it's safe to assume that data will always be present when this code runs.
  return getMetaContent<ShareRoomFragment>("room-data", { json: true })
}

export const getTopMessages = () => {
  const messages = getMetaContentMaybe<ShareMessageFragment[]>("top-messages", { json: true })
  return messages?.length ? messages : null
}
